export default {
  AED: {
    enabled: false,
    format: "%v %s",
    symbol: "د.إ."
  },
  AFN: {
    enabled: false,
    format: "%v%s",
    symbol: "؋"
  },
  ALL: {
    enabled: false,
    format: "%s%v",
    symbol: "Lek",
    decimal: ",",
    thousand: "."
  },
  AMD: {
    enabled: false,
    format: "%v %s",
    symbol: "AMD",
    decimal: ",",
    thousand: "."
  },
  ANG: {
    enabled: false,
    format: "%s%v",
    symbol: "ƒ",
    decimal: ",",
    thousand: "."
  },
  AOA: {
    enabled: false,
    format: "%s%v",
    symbol: "Kz"
  },
  ARS: {
    enabled: false,
    format: "%s%v",
    symbol: "$",
    decimal: ",",
    thousand: "."
  },
  AUD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  AWG: {
    enabled: false,
    format: "%s%v",
    symbol: "ƒ"
  },
  AZN: {
    enabled: false,
    format: "%s%v",
    symbol: "₼",
    decimal: ",",
    thousand: "."
  },
  BAM: {
    enabled: false,
    format: "%s%v",
    symbol: "KM",
    decimal: ",",
    thousand: "."
  },
  BBD: {
    enabled: false,
    format: "%s%v",
    symbol: "Bds$"
  },
  BDT: {
    enabled: false,
    format: "%s%v",
    symbol: "৳"
  },
  BGN: {
    enabled: false,
    format: "%v %s",
    symbol: "лв.",
    decimal: ".",
    thousand: "'"
  },
  BHD: {
    enabled: false,
    format: "%v %s",
    symbol: ".د.ب",
    scale: 3
  },
  BIF: {
    enabled: false,
    format: "%s%v",
    symbol: "$",
    scale: 0
  },
  BMD: {
    enabled: false,
    format: "%v %s",
    symbol: "FBu"
  },
  BND: {
    enabled: false,
    format: "%s%v",
    symbol: "B$"
  },
  BOB: {
    enabled: false,
    format: "%s%v",
    symbol: "$b"
  },
  BRL: {
    enabled: false,
    format: "%s%v",
    symbol: "R$",
    decimal: ",",
    thousand: "."
  },
  BSD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  BTN: {
    enabled: false,
    format: "%s%v",
    symbol: "Nu."
  },
  BWP: {
    enabled: false,
    format: "%s%v",
    symbol: "P"
  },
  BYR: {
    enabled: false,
    format: "%s%v",
    symbol: "p.",
    decimal: ",",
    thousand: ".",
    scale: 0
  },
  BZD: {
    enabled: false,
    format: "%s%v",
    symbol: "BZ$"
  },
  CAD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  CDF: {
    enabled: false,
    format: "%v %s",
    symbol: "CDF"
  },
  CHF: {
    enabled: false,
    format: "%s%v",
    symbol: "CHF"
  },
  CLP: {
    enabled: false,
    format: "%s%v",
    symbol: "$",
    decimal: ",",
    thousand: ".",
    scale: 0
  },
  CNY: {
    enabled: true,
    format: "%s%v",
    symbol: "¥"
  },
  COP: {
    enabled: false,
    format: "%s%v",
    symbol: "$",
    decimal: ",",
    thousand: "."
  },
  CRC: {
    enabled: false,
    format: "%s%v",
    symbol: "₡",
    decimal: ",",
    thousand: "."
  },
  CUC: {
    enabled: false,
    format: "%s%v",
    symbol: "CUC$",
    decimal: ",",
    thousand: "."
  },
  CUP: {
    enabled: false,
    format: "%s%v",
    symbol: "₱",
    decimal: ",",
    thousand: "."
  },
  CVE: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  CZK: {
    enabled: false,
    format: "%v%s",
    symbol: "Kč",
    decimal: ",",
    thousand: "."
  },
  DJF: {
    enabled: false,
    format: "%v %s",
    symbol: "Fdj",
    scale: 0
  },
  DKK: {
    enabled: false,
    format: "%s%v",
    symbol: "kr"
  },
  DOP: {
    enabled: false,
    format: "%s%v",
    symbol: "RD$",
    decimal: ",",
    thousand: "."
  },
  DZD: {
    enabled: true,
    format: "%v %s",
    symbol: "دج"
  },
  EGP: {
    enabled: true,
    format: "%s%v",
    symbol: "£",
    decimal: ",",
    thousand: "."
  },
  INR: {
    enabled: false,
    format: "%s%v",
    symbol: "₹"
  },
  NOK: {
    enabled: false,
    format: "%s%v",
    symbol: "kr"
  },
  USD: {
    enabled: true,
    format: "%s%v",
    symbol: "$"
  },
  EUR: {
    enabled: true,
    format: "%v %s",
    symbol: "€",
    decimal: ",",
    thousand: "."
  },
  ERN: {
    enabled: false,
    format: "%v %s",
    symbol: "ናቕፋ",
    decimal: ",",
    thousand: "."
  },
  ETB: {
    enabled: false,
    format: "%s%v",
    symbol: "Br"
  },
  FJD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  FKP: {
    enabled: false,
    format: "%s%v",
    symbol: "£"
  },
  GBP: {
    enabled: true,
    format: "%s%v",
    symbol: "£"
  },
  GEL: {
    enabled: false,
    format: "%v %s",
    symbol: "GEL"
  },
  GHS: {
    enabled: false,
    format: "%s%v",
    symbol: "GH¢"
  },
  GIP: {
    enabled: false,
    format: "%s%v",
    symbol: "£"
  },
  GNF: {
    enabled: false,
    format: "%v %s",
    symbol: "FG",
    scale: 0
  },
  GTQ: {
    enabled: false,
    format: "%s%v",
    symbol: "Q"
  },
  GYD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  HKD: {
    enabled: false,
    format: "%s%v",
    symbol: "HK$",
    decimal: ","
  },
  HRK: {
    enabled: false,
    format: "%s%v",
    symbol: "kn"
  },
  HUF: {
    enabled: false,
    format: "%s%v",
    symbol: "Ft"
  },
  IDR: {
    enabled: false,
    format: "%s%v",
    symbol: "Rp",
    decimal: ",",
    thousand: "."
  },
  ILS: {
    enabled: true,
    format: "%s%v",
    symbol: "₪"
  },
  ISK: {
    enabled: false,
    format: "%s%v",
    symbol: "kr",
    scale: 0
  },
  JPY: {
    enabled: false,
    format: "%s%v",
    symbol: "¥",
    scale: 0
  },
  KWD: {
    enabled: false,
    format: "%s%v",
    symbol: "ك"
  },
  KRW: {
    enabled: false,
    format: "%s%v",
    symbol: "₩",
    scale: 0
  },
  KZT: {
    enabled: false,
    format: "%v %s",
    symbol: "KZT"
  },
  MAD: {
    enabled: false,
    format: "%v %s",
    symbol: "د.م.",
    decimal: ",",
    thousand: "."
  },
  MMK: {
    enabled: false,
    format: "%s%v",
    symbol: "K"
  },
  MRO: {
    enabled: false,
    format: "%v %s",
    symbol: "UM"
  },
  MXN: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  MYR: {
    enabled: false,
    format: "%s%v",
    symbol: "RM"
  },
  NZD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  NGN: {
    enabled: true,
    format: "%s%v",
    symbol: "₦"
  },
  PHP: {
    enabled: false,
    format: "%s %v",
    symbol: "PHP"
  },
  PLN: {
    enabled: false,
    format: "%v %s",
    symbol: "zł",
    decimal: ",",
    thousand: " "
  },
  QAR: {
    enabled: false,
    format: "%s%v",
    symbol: "﷼"
  },
  RUB: {
    enabled: true,
    format: "%v %s",
    symbol: "руб.",
    decimal: ",",
    thousand: " ",
    scale: 0,
    where: "right"
  },
  SAR: {
    enabled: false,
    format: "%s%v",
    symbol: "﷼"
  },
  SEK: {
    enabled: false,
    format: "%s%v",
    symbol: "kr"
  },
  SGD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  THB: {
    enabled: false,
    format: "%s%v",
    symbol: "฿"
  },
  TND: {
    enabled: false,
    format: "%v %s",
    symbol: "DT",
    decimal: ","
  },
  TWD: {
    enabled: false,
    format: "%s%v",
    symbol: "NT$"
  },
  UAH: {
    enabled: false,
    format: "%s%v",
    symbol: "₴",
    decimal: ","
  },
  VND: {
    enabled: false,
    format: "%v %s",
    symbol: "₫",
    decimal: ",",
    thousand: ".",
    scale: -2,
    where: "right"
  },
  XAF: {
    enabled: false,
    format: "%v %s",
    symbol: "CFA",
    scale: 0
  },
  XCD: {
    enabled: false,
    format: "%s%v",
    symbol: "$"
  },
  XOF: {
    enabled: false,
    format: "%v %s",
    symbol: "CFA",
    scale: 0
  }
};
